
import { createClient } from '@supabase/supabase-js'

// Use environment variables with fallback to demo values
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://demo.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'demo-key'

// Check if we're using real credentials
const isRealSupabase = supabaseUrl !== 'https://demo.supabase.co' && 
                      supabaseUrl !== 'https://your-new-project-id.supabase.co' &&
                      !supabaseUrl.includes('your-project-id')

// Create and export the Supabase client (even with demo credentials for structure)
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Export flag for checking if database is available
export const isDatabaseAvailable = isRealSupabase

// Log connection status (only in development)
if (import.meta.env.DEV) {
  console.log('Supabase client initialized with URL:', supabaseUrl)
  if (!isRealSupabase) {
    console.warn('⚠️ Using demo Supabase credentials. Database operations will be disabled.')
    console.warn('📖 To fix: Create a project at https://supabase.com and update your .env file')
  }
}
